// libs
import React, { memo, useState, useEffect } from 'react';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// styles
import { TransitionOverlay, TransitionText, LoaderContainer, GifImage } from './styles';

interface ISwitchTransitionScreenProps {
  onRedirect: () => void;
  storeToRedirect: string;
  customText?: string;
  showCountdown?: boolean;
}

function SwitchTransitionScreen({
  onRedirect,
  storeToRedirect,
  customText,
  showCountdown = true,
}: ISwitchTransitionScreenProps) {
  // @ts-ignore: any since store can't be hardcoded as enums
  const { transitionScreen } = useRemoteConfig('storeSwitchBanner')?.[storeToRedirect] || {};
  const { text, countDown, showTimer, lottieUrl } = transitionScreen || {};

  const [sec, setSec] = useState<number>(countDown);

  useEffect(() => {
    const interval = setInterval(() => {
      setSec((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          onRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [onRedirect]);

  const displayText = customText ?? text;
  const textToShow = showCountdown && showTimer ? `${displayText} in ${sec}s` : displayText;

  return (
    <TransitionOverlay>
      <LoaderContainer>{lottieUrl && <GifImage src={lottieUrl} alt="" />}</LoaderContainer>
      <TransitionText>{textToShow}</TransitionText>
    </TransitionOverlay>
  );
}

export default memo(SwitchTransitionScreen);
